import { useMediaQuery } from '@chakra-ui/react';

import { breakpoints } from 'app/themeConfig';

/**
 * Он возвращает объект с булевыми значениями, указывающими, какой тип устройства использует пользователь:
 * - `isMobileDevice`: true, если пользователь использует устройство с шириной экрана меньше '992px'.
 * - `isDesktopDevice`: true, если пользователь использует устройство с шириной экрана больше '992px'.
 *
 * Также при помощи аргумента `customBreakpoint` можно прокинуть в хук любой другой брейкпоинт в формате '992px'
 *
 * @example
 * import { useMobileDevice } from 'shared/hooks';
 *
 * function ExampleComponent() {
 *   const { isMobileDevice, isDesktopDevice } = useMobileDevice();
 *
 *   return (
 *     <div>
 *       {isMobileDevice ? 'Мобильное устройство' : 'Десктоп'}
 *       {isDesktopDevice ? 'Десктоп' : 'Мобильное устройство'}
 *     </div>
 *   );
 * }
 */
export const useMobileDevice = (customBreakpoint = null) => {
  const [isMobileDevice] = useMediaQuery(`(max-width: ${customBreakpoint ?? breakpoints.laptop})`);

  return { isMobileDevice, isDesktopDevice: !isMobileDevice };
};
